import "jquery-ui/ui/widgets/draggable";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/sortable";
import "jquery-ui/ui/widgets/spinner";

import "../../../node_modules/jquery-ui/themes/base/all.css";

import { SessionTimeout } from "./session_timeout";
import { Viewer } from "./viewer";

import "./webgl_board";
import "./MeasuringTool";
import "./keyboard-shortcuts";
import registerFastTrackMethods from "./fastTrack";
import { BFF_BASE_PATH } from "@/core/utils"

globals.alerts_panel_in_focus = false;
globals.is_server_last_connection_ok = true;
globals.ping_interval_msec = 15000;
globals.SYSTEM_STATE_READY = "Ready for review";
globals.current_slide;
globals.num_of_alerts = "0";
globals.current_alerts_ids_ordered = [];
globals.current_alert_index = 0;
globals.alerts_to_slides_map = {};
globals.ping_retry = 0;

document.body.addEventListener("event-bridge-api", function (event) {
  $(document).trigger(event.detail.eventName, event.detail.data);
});

function clearCanvas() {
  if (globals?.viewer) {
    globals.viewer.clear_canvas(); // undisplay slide
    globals.current_slide = null;
  }
}

$(document).on("clear-canvas-from-vue", (event, data) => {
  console.log("clear canvas from vue");
  clearCanvas();
});

$(document).on("case-selected-from-vue", (event, data) => {
  if (globals.active_case && globals.active_case.case.caseId !== data.case.caseId) {
    clearCanvas();
  }
  globals.active_case = data;

  if (globals.isSecondRead) {
    globals.current_alerts_ids_ordered = [];
    globals.current_alert_index = 0;
    globals.alerts_to_slides_map = {};
    globals.num_of_alerts = globals.active_case.case.alerts.total;
    $("#alerts_btn").prop("disabled", false);
    $("#alerts_btn").html(getCaseAlertsHtml(globals.active_case.case));
    data.slides.map((slide) => {
      if (slide.alerts.length) {
        slide.alerts.forEach((alert, index) => {
          globals.current_alerts_ids_ordered.push(alert.alertId);
          globals.alerts_to_slides_map[alert.alertId] = { slide, index };
        });
      }
    });
    // add all alert ids to globals.current_alerts_ids_ordered
  }
  // if firstread && with reports
  $("body").trigger("ibex:case-selected", data.case.caseId);
});

window.eventsQueue = [];

$(document).on("slide-selected-from-vue", (event, data) => {
  globals.current_slide = data.valueOf().slide;
  if (window.slide_selected) {
    window.slide_selected(globals.current_slide, data.valueOf().alertIndex);
  } else {
    window.eventsQueue.push({
      name: "slide-selected-from-vue",
      data,
    });
  }
});

$(document).on("set-zoom-and-location-from-vue", (event, { zoom, x, y }) => {
  globals.viewer.SetZoomAndLocation(zoom, x, y);
});

$(document).on("active-insight-changed", (event) => {
  globals.viewer.SetZoom2Fit();
});

$(document).on("app-ready", (event, data) => {
  globals.alerts_config = data.globals.alerts_config;
  globals.inactiveTimeout = new SessionTimeout(data.config.inactivity_timeout_sec);
  utils.urlHelper.init(data.config.number_of_servers);
  $("body").trigger("config-ready", data.config);

  globals.viewer = new Viewer();

  window.clear_all_widgets = function () {
    var elements = document.getElementsByClassName("clear_all_widgets_on_click");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "none";
    }
    $("#pref_btn").removeClass("pref-btn-is-active");
    $("#alerts_btn").removeClass("alerts-btn-is-active");

    let $container = $("#container");
    let $caseReportToggle = $("#case_report_toggle");
    if ($caseReportToggle && $container.hasClass("case-report-open")) {
      $caseReportToggle.click();
    }
  };

  window.clear_all_widgets();
  get_user_preferences();
  registerFastTrackMethods();

  initialize();

  function show_widget_inline(widget_name) {
    var x = document.getElementById(widget_name);
    x.style.display = "inline";
  }

  window.getCaseAlertsHtml = function (_case) {
    let html = "";

    if (_case.alerts.clinical)
      html += `<span class='dot alerts_style clinical' title='Clinical alerts'>${_case.alerts.clinical}</span>`;

    if (_case.alerts.technical)
      html += `<span class='dot alerts_style technical' title='Technical alerts'>${_case.alerts.technical}</span>`;

    return html;
  };

  // get the slide row in slides table selected and the cell number
  // cell number indicate which operation is needed
  // slide is loaded  with alert information if exist and related controls are updated
  window.slide_selected = function (slide, alertIndex) {
    $("#zoom_btn").prop("disabled", false);
    $("#cases_btn").hide();

    const alert = slide.alerts ? slide.alerts[alertIndex] : null;
    const alertID = alert ? alert.alertId : null;
    let alert_type = "";
    let confidence = "";
    let resolution = "";
    let comments = "";
    let locations = null;
    if (alert != null) {
      locations = alert.location;
      if (!Object.keys(locations).length) {
        locations = null;
      }
      alert_type = alert.alertType;
      confidence = alert.confidence;
      resolution = alert.resolution;
      comments = alert.comments;
    }

    try {
      confidence = parseFloat(confidence).toFixed(2);
    } catch (err) {}

    globals.current_slide = new Slide(
      slide.slideId,
      slide.stain,
      alert_type,
      confidence,
      resolution,
      comments,
      alertID,
      locations
    );

    //todo: change all to encodeUTIComponent() and <path:> approach
    var slide_id_without_slash = slide.slideId.replace("/", "[@slash]").replace("#", "[@pound]");
    window.current_slide_id = slide_id_without_slash;

    $("#container").addClass("loading");
    load_button(function (isCallSucceded) {
      $("#container").removeClass("loading");
      if (isCallSucceded) {
        clear_all_widgets();
        if (globals.isSecondRead && alertID != null) {
          globals.current_alert_index = globals.current_alerts_ids_ordered.indexOf(alertID);
          load_data_to_alerts_panel();
          get_alert_heatmap_and_display(globals.current_slide);
          if ($("#alerts_panel").css("display") == "none") {
            toggleButton("alerts_panel");
            $("#alerts_btn").addClass("alerts-btn-is-active");
          }
        }
        if (!globals.isSecondRead && !process.env.CONFIG_ENABLE_REPORTS) {
          // todo: get from config
          utils.eventBridgeApi("show-heatmap-if-exists", {
            heatmaps: [slide.screeningClass === "Benign" ? "ScreeningPOIs" : "Cancer"],
            isToggle: true,
          });
        }
      } else {
        // some logic to handle a case where slide could not be loaded
      }
    }, 3);
  };

  function get_next_alert() {
    globals.current_alert_index++;
    globals.current_alert_index = globals.current_alert_index % globals.num_of_alerts;
    return globals.alerts_to_slides_map[
      globals.current_alerts_ids_ordered[globals.current_alert_index]
    ];
  }

  function get_prev_alert() {
    globals.current_alert_index--;
    if (globals.current_alert_index < 0) {
      globals.current_alert_index = globals.num_of_alerts - 1;
    }
    return globals.alerts_to_slides_map[
      globals.current_alerts_ids_ordered[globals.current_alert_index]
    ];
  }

  function load_data_to_alerts_panel() {
    if (globals.num_of_alerts == 0) {
      return false;
    }

    if (globals.current_slide == null || globals.current_slide.alertID == undefined) return false;

    var alertTypeText =
      globals.alerts_config.alert_type_dict[globals.current_slide.alert_type] == null
        ? globals.current_slide.alert_type
        : window.app.t(`config.alert.alert_type_dict.${globals.current_slide.alert_type}`);

    $("#alert_header").text(
      window.app.t("alerts.alert_of", {
        index: (globals.current_alert_index % globals.num_of_alerts) + 1,
        total: globals.num_of_alerts,
      })
    );
    $("#alerts_panel_type").text(window.app.t(alertTypeText));
    $("#alerts_panel_confidence").text(
      window.app.$n(
        Number.parseFloat(globals.current_slide.confidence),
        'decimal'));
    $("#alerts_panel_resolution").val(globals.current_slide.resolution);
    $("#alerts_panel_comments").val(globals.current_slide.comments);
    return true;
  }

  function replace_slash(name) {
    return name.replace("/", "[@slash]").replace("#", "[@pound]");
  }

  function do_polling_method() {
    if (!globals.is_server_last_connection_ok) {
      console.log("Polling Ping interval [msec]:" + globals.ping_interval_msec);
      ping_server();
      setTimeout(do_polling_method, globals.ping_interval_msec);
    }
  }

  function handle_connection_change_notify_user(is_connection_ok) {
    var message = "";
    if (is_connection_ok) {
      message = window.app.t("connection_change_notify_user_ok"); //"Connection to the server has been restored.\nAll functionality will now revert to normal.";
    } else {
      message = window.app.t("connection_change_notify_user_err"); //"Failed to connect to the server.\nFunctions for providing feedback will be temporarily unavailable.\nYou may continue using other features of the application.\nAnother message shall appear upon reconnecting with the server.";
    }
    // pop up a proper alert message
    alert(message);
  }

  function handle_connection_change_enable_gui_elements(is_connection_ok) {
    if (is_connection_ok) {
      $(".resolution").prop("disabled", false);
      $(".comment").prop("disabled", false);
      $("#alerts_panel_resolution").prop("disabled", false);
      $("#alerts_panel_comments").prop("disabled", false);
    } else {
      $(".resolution").prop("disabled", true);
      $(".comment").prop("disabled", true);
      $("#alerts_panel_resolution").prop("disabled", true);
      $("#alerts_panel_comments").prop("disabled", true);
    }
  }

  function ping_server() {
    $.ajax({
      type: "GET",
      url: `${BFF_BASE_PATH}/get_ping_status`,
      dataType: "json",
      timeout: "3000",
      error: function (jqXHR, textStatus, errorThrown) {
        if (globals.ping_retry < 3) {
          globals.ping_retry++;
          ping_server();
          return;
        }
        globals.ping_retry = 0;
        utils.handleServerError("ping_server", jqXHR, textStatus);
        return;
      },
      success: function (_data) {
        globals.ping_retry = 0;
        var new_interval_result = _data["client_ping_interval_msec"];
        if (globals.ping_interval_msec != new_interval_result) {
          globals.ping_interval_msec = new_interval_result;
          console.log("Received new ping_interval_msec:" + globals.ping_interval_msec);
        }
        globals.ping_result = _data["status"] == "OK" ? true : false;

        // handel result if state has changed
        handle_connection_result(globals.ping_result);
        return;
      },
    });
  }

  function handle_connection_result(ping_result) {
    if (globals.is_server_last_connection_ok != ping_result) {
      console.log("Server connection has changed. is_ping_ok=" + ping_result);
      globals.is_server_last_connection_ok = ping_result;
      handle_connection_change_notify_user(globals.is_server_last_connection_ok);
      handle_connection_change_enable_gui_elements(globals.is_server_last_connection_ok);
      if (!globals.is_server_last_connection_ok) {
        // start polling
        do_polling_method();
      } else {
        // stop polling - no action needed because - is_server_last_connection_ok==false
      }
    }
  }

  function get_user_preferences() {
    $.ajax({
      type: "GET",
      url: `${BFF_BASE_PATH}/get_preferences`,
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        utils.handleServerError("get_preferences", jqXHR, textStatus);
      },
      success: function (_data) {
        globals.userPreferences = _data;

        $("#cb_invert_scroll_wheel")[0].checked = globals.userPreferences.cb_invert_scroll_wheel;
      },
    });
  }

  function initialize() {
    $("#alerts_btn").prop("disabled", true);
    if (globals.isSecondRead) $("#alerts_btn").css("display", "block");

    $("#alerts_panel_comments").focusin(function () {
      globals.alerts_panel_in_focus = true;
    });
    $("#alerts_panel_comments").focusout(function () {
      globals.alerts_panel_in_focus = false;
    });
    $("#next_alert").click(function (event) {
      navigate_alerts(true);
    });
    $("#previous_alert").click(function (event) {
      navigate_alerts(false);
    });

    $("#cb_invert_scroll_wheel").on("click", function (e) {
      utils.savePreferences();
    });

    $("#zoom_buttons_panel").hover(
      function () {
        if (globals.current_slide != null) show_widget_inline("zoom_buttons_panel");
      },
      function () {
        var x = document.getElementById("zoom_buttons_panel");
        x.style.display = "none";
      }
    );

    $("#zoom_buttons_panel").click(
      function () {
        var x = document.getElementById("zoom_buttons_panel");
        x.style.display = "none";
      }
    );
    
    $("#zoom_btn").hover(
      function () {
        if (globals.current_slide != null) show_widget_inline("zoom_buttons_panel");
      },
      function () {
        var x = document.getElementById("zoom_buttons_panel");
        x.style.display = "none";
      }
    );
    // cancel button default behaviour press spacebar/enter -> click when button is in focus
    $(":button").keypress(function (event) {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode == "32" || keycode == "13") {
        event.preventDefault();
      }
    });
    $(":button").keyup(function (event) {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode == "32" || keycode == "13") {
        event.preventDefault();
      }
    });
    $("body").on("click", ".cases_view", function (event) {
      ping_server();
      clearCanvas();
      utils.eventBridgeApi("show_cases_view");
      $("#alerts_btn").empty();
      clear_all_widgets();
      if ($("#container").is(".slide-report-open")) {
        $("#container").removeClass("slide-report-open");
      }
      $("#cases_panel").show();
    });
    $("body").on("click", ".case_view", function (event) {
      ping_server();
      clearCanvas();
      utils.eventBridgeApi("show_case_view");
      clear_all_widgets();
      if ($("#container").is(".slide-report-open")) {
        $("#container").removeClass("slide-report-open");
      }
      $("#cases_panel").show();
    });
    $("#pref_btn").click(function (event) {
      toggleButton("preferences_panel");
      if ($("#preferences_panel").css("display") == "none") {
        $("#pref_btn").removeClass("pref-btn-is-active");
      } else {
        $("#pref_btn").addClass("pref-btn-is-active");
      }
    });
    $("#alerts_btn").click(function (event) {
      if (load_data_to_alerts_panel()) {
        if ($("#alerts_panel").css("display") == "none") {
          get_alert_heatmap_and_display();
        }

        toggleButton("alerts_panel");
        if ($("#alerts_panel").css("display") != "none") {
          $("#alerts_btn").addClass("alerts-btn-is-active");
        }
      } else if (globals.num_of_alerts > 0) {
        // no alerts in current slide
        $("#next_alert").trigger("click");
      }
    });
    $("#close_cases_panel").click(function (event) {
      clear_all_widgets();
    });
    $("#close_case_report").click(function (event) {
      $("#case_report_toggle").click();
    });

    ping_server();

    $("#zoom_buttons_panel")
      .children("button")
      .each(function () {
        $(this).click(function () {
          globals.viewer.SetZoom(this.value);
        });
      });

    $("#alerts_panel_resolution").change(function () {
      var resolution = $("#alerts_panel_resolution option:selected").val();
      globals.current_slide.resolution = resolution;
      update_resolution(globals.current_slide.slide_id, globals.current_slide.alertID, resolution);
    });

    $("#alerts_panel_comments").change(function () {
      var comments = $("#alerts_panel_comments").val();
      globals.current_slide.comments = comments;
      update_comment_in_server(
        globals.current_slide.slide_id,
        globals.current_slide.alertID,
        comments
      );
    });
    $("#close_alerts_panel").click(function (event) {
      utils.hide_widget_inline_blocked("alerts_panel");
      $("#alerts_btn").removeClass("alerts-btn-is-active");

      //            clear_all_widgets();
    });
    toggleButton("cases_panel");
  } // initialize() end

  function toggleButton(element_name) {
    var skip = false;
    if ($("#" + element_name).css("display") != "none") {
      skip = true;
    }
    clear_all_widgets();
    if (!skip) {
      utils.show_widget_inline_blocked(element_name);
    }
  }

  function load_button(callback, retries) {
    $.ajax({
      type: "GET",
      url: `${BFF_BASE_PATH}/image_properties_fast/` + window.current_slide_id,
      dataType: "json",
      timeout: "10000",
      success: function (data) {
        globals.viewer.Init(data);
        $("body").trigger("ibex:slide-selected", data);
        utils.eventBridgeApi("slide-loaded", data);
        utils.dispatchCustomEvent("heatmaps-pan-zoom", $("#heatmaps").get(0), {
          viewer: globals.viewer,
          resetViewerSize: true,
        });
        callback(true);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (retries > 0) {
          load_button(callback, --retries);
        } else {
          utils.handleServerError("load_button", jqXHR, textStatus);
          callback(false);
        }
      },
    });
  }

  function update_alert_heatmap(current_slide) {
    const alert_type = current_slide.alert_type;
    const heatmap = globals.alerts_config.alerts[alert_type].classification;
    const opacity = globals.alerts_config.alerts[alert_type].opacity;

    if (globals.isSecondRead) {
      $("#alerts_panel_resolution")
        .empty()
        .append($(get_resolution_options_html(alert_type, current_slide.resolution)));
    }
    utils.eventBridgeApi("apply-heatmap-state", {
      opacity,
      heatmap,
    });
  }

  function get_alert_heatmap_and_display() {
    const locations = globals.current_slide.locations;
    update_alert_heatmap(globals.current_slide);
    if (locations != null) {
      globals.viewer.SetZoomAndLocation(locations["zoom"], locations["x"], locations["y"]);
    }
    if (globals.viewer.measuringTool && globals.viewer.measuringTool.isOpen) {
      globals.viewer.measuringTool.resetAndHide();
    }
  }

  function navigate_alerts(next) {
    const slideAndAlert = next ? get_next_alert() : get_prev_alert();
    slide_selected(slideAndAlert.slide, slideAndAlert.index); // send correct index
  }

  window.navigate_slides = function (next) {
    const slides = globals.active_case.slides;
    if (slides.length <= 1) return;
    let nextSlide;
    for (let i = 0; i < slides.length; i++) {
      if (slides[i]["slideId"] != globals.current_slide["slide_id"]) continue;
      var next_valid = false;
      // find next valid slide
      var j;
      var ii = i;
      while (!next_valid) {
        if (next) j = (ii + 1) % slides.length;
        else if (ii == 0) j = slides.length - 1;
        else j = ii - 1;
        if (j == i)
          // meaning the only valid slide is the current slide
          return;
        next_valid = slides[j]["systemStatus"] == globals.SYSTEM_STATE_READY;
        ii = j;
      }
      nextSlide = slides[j];
    }
    slide_selected(nextSlide, 0);
  };

  function update_resolution(slide, alert, resolution) {
    $.ajax({
      type: "POST",
      url: `${BFF_BASE_PATH}/update_resolution/`,
      dataType: "text",
      contentType: "application/json",
      data: JSON.stringify({
        case_id: globals.active_case.case.caseId,
        slide_id: slide,
        alert_id: alert,
        resolution,
      }),
      error: function (jqXHR, textStatus, errorThrown) {
        utils.handleServerError("update_resolution", jqXHR, textStatus);
        ping_server();
        return false;
      },
      success: function (data) {
        utils.eventBridgeApi("resolution-updated", JSON.parse(data));
        globals.alerts_to_slides_map[alert].slide.alerts.find((alertObj) => {
          if (alertObj.alertId === alert) alertObj.resolution = resolution;
        });
      },
    });
  }

  function update_comment_in_server(slide, alert, comment) {
    var alert_id = alert; //replace_slash(alert);
    var slide_id = replace_slash(slide);
    $.ajax({
      type: "PUT",
      url: `${BFF_BASE_PATH}/update_comment/` + slide_id + "/" + alert_id,
      data: JSON.stringify({ comments: comment }),
      contentType: "application/json",
      error: function (jqXHR, textStatus, errorThrown) {
        utils.handleServerError("update_comment_in_server", jqXHR, textStatus);
        ping_server();
        return false;
      },
      success: function (data) {
        globals.active_case.slides.map((s) => {
          if (s.slideId == slide) {
            s.alerts[0].comments = comment;
          }
        });
        utils.eventBridgeApi("comment-updated", data);
        console.log(
          "update_comment_in_server " + slide + " " + alert_id + " " + comment + " " + data
        );
      },
    });
  }

  function get_resolution_options_html(slideAlertType, slideResolution) {
    var content = "";
    // todo: get specific alert options
    var options = globals.alerts_config.alerts[slideAlertType]["resolutions"];
    var found = false;
    var val;
    for (var i = 0; i < options.length; i++) {
      if (options[i] == slideResolution) {
        val =
          globals.alerts_config.resolutions_dict[slideResolution] == null
            ? slideResolution
            : globals.alerts_config.resolutions_dict[slideResolution];
        content +=
          '<option value="' + window.app.t(slideResolution) + '" selected>' + val + "</option>";
        found = true;
      } else {
        content +=
          '<option value="' +
          options[i] +
          '">' +
          window.app.t(globals.alerts_config.resolutions_dict[options[i]]) +
          "</option>";
      }
    }
    if (!found) {
      val =
        globals.alerts_config.resolutions_dict[slideResolution] == null
          ? slideResolution
          : globals.alerts_config.resolutions_dict[slideResolution];
      content +=
        '<option value="' + window.app.t(slideResolution) + '" selected>' + val + "</option>";
    }
    return content;
  }

  // run queued events
  window.eventsQueue.forEach((queuedEvent) => {
    $(document).trigger(queuedEvent.name, queuedEvent.data);
  });
});

class Slide {
  constructor(
    slide_id,
    stain,
    alert_type,
    confidence,
    resolution,
    comments,
    alertID,
    locations = null,
    alert_index = 0
  ) {
    this.slide_id = slide_id;
    this.stain = stain;
    this.alert_type = alert_type;
    this.confidence = confidence;
    this.resolution = resolution;
    this.comments = comments;
    this.alertID = alertID;
    this.locations = locations;
    // alert index in slide alerts
    this.alert_index = alert_index;
  }
}
